import { withInstall } from '@fx-front-framework/utils/with-install'
import VPanel from './src/index.vue'

export const FxVPanel = withInstall(VPanel)
export default FxVPanel
